import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,
    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Felelős műszaki vezetés</Title>
        <p>
          Az építési munkaterületen végzett építési-szerelési munkát a felelős műszaki vezető irányítja. A felelős
          műszaki vezető tevékenysége a vállalkozó (alvállalkozó) kivitelező kivitelezési szerződésében vállalt
          építőipari kivitelezési tevékenységnek vagy meghatározott részének irányítására terjed ki, ahogy erről az
          építőipari kivitelezési tevékenységről szóló 191/2009. (IX.15.) Kormányrendelet rendelkezik.
        </p>
        <p>
          <strong>A felelős műszaki vezető feladata:</strong>
        </p>
        <ul>
          <li>
            az építési-szerelési munkára vonatkozó jogszabályok (szakmai és minőségi követelmények), munkavédelmi,
            tűzvédelmi, környezetvédelmi, műemlékvédelmi, természetvédelmi, közegészségügyi és más kötelező hatósági
            előírások, továbbá az építésügyi hatósági (létesítési) engedélyek betartatása, azok betartásának az általa
            vezetett építkezésen való ellenőrzése,
          </li>
          <li>az építési napló vezetése, ellenőrzése és lezárása, ha erre a kivitelezőtől megbízást kapott, </li>
          <li>az építőipari kivitelezési tevékenység munkafolyamatainak szakszerű megszervezése, </li>
          <li>
            a kivitelezés során a minőségi követelmények biztosítása, a technológiai, a munkavédelmi és az egészségügyi
            előírások betartatása,
          </li>
          <li>a kitűzés helyességének, valamint a geotechnikai és egyéb vizsgálatok megtörténtének ellenőrzése, </li>
          <li>a minőségi vizsgálatok és mintavételek elvégeztetése, </li>
          <li>az azonnali intézkedést igénylő építési műszaki feladatok meghatározása és irányítása, </li>
          <li>
            a kivitelezési tervektől eltérő, nem építési (létesítési) engedélyköteles kivitelezésnek az építési naplóban
            történő feltüntetése,
          </li>
          <li>
            az építőipari kivitelezési tevékenység befejezésekor, az építési napló alapján az 5. melléklet szerinti
            hulladék nyilvántartó lap kitöltése és az építtetőnek történő átadása,
          </li>
          <li>
            az építmény használatbavételi (fennmaradási) engedélyezéséhez, tudomásulvételéhez a felelős műszaki
            vezetőnek szakterületére vonatkozó nyilatkozat megtétele,
          </li>
          <li>
            az átadás-átvételi eljárásban és a használatbavételi engedélyezési eljárásban való közreműködés és az ehhez
            szükséges nyilatkozatok megtétele,
          </li>
          <li>
            <span>az alvállalkozói teljesítés igazolása, mely tartalmazza</span>
            <ul>
              <li>
                a teljesített kivitelezési munkák meghatározását, mennyiségét és minőségét, a teljesítés időpontját,
              </li>
              <li>a teljesítésigazolás alapján számlázható összeget, </li>
              <li>
                a szerződésben meghatározott alvállalkozói díj és a teljesítésigazolásban megjelölt számlázható összeg
                eltérése esetén az eltérés indoklását,
              </li>
            </ul>
          </li>
          <li>
            <span>az alvállalkozói teljesítésigazolás</span>
            <ul>
              <li>kiállítása és átadása vagy megküldése az alvállalkozó részére,</li>
              <li>rögzítése az építési naplóban,</li>
            </ul>
          </li>
          <li>
            az alvállalkozó kivitelező által megküldött, teljesítésről szóló értesítés kézhezvételétől – ha szerződés
            vagy jogszabály átadás-átvételi eljárást határoz meg, ennek lezárásától – számított, szerződésben
            meghatározott, de legfeljebb tizenöt munkanapon belül,
          </li>
          <li>
            értesíteni az illetékes környezetvédelmi és természetvédelmi hatóságot arról, hogy az építési munkaterületen
            keletkezett építési-bontási hulladék mennyisége eléri az építési és bontási hulladék kezelésének részletes
            szabályairól szóló jogszabályban előírt küszöbértéket,
          </li>
          <li>
            annak ellenőrzése, hogy az építménybe csak a tervező által a kivitelezési dokumentációban meghatározott,
            legalább az elvárt műszaki teljesítményű építési termék kerüljön beépítésre, és a szakszerű beépítés
            ellenőrzése,
          </li>
          <li>
            az építési naplóban történő rögzítés mellett a tervező által a kivitelezési dokumentációban megjelölt
            építési termék helyett a megadottal azonos vagy annál jobb teljesítményértékű helyettesítő építési termék
            kiválasztása a tervező jóváhagyásával és az építtető egyetértésével.
          </li>
        </ul>
        <p>
          A felelős műszaki vezetőre vonatkozó további fontos jogszabály az építésügyi és az építésüggyel összefüggő
          szakmagyakorlási tevékenységekről szóló 266/2013. (VII. 11.) Korm. rendelet; ennek 22. §-a foglalkozik
          témánkkal és többek között kitér az alábbiakra.
        </p>
        <p>
          A felelős műszaki vezetői tevékenység folytatásához szükséges szerződés megkötésére a Ptk.-ban szabályozott
          megbízási szerződés szabályait kell alkalmazni azzal az eltéréssel, hogy
        </p>
        <ul>
          <li>a szerződést írásban kell megkötni,</li>
          <li>
            <span>a szerződés tartalmazza</span>
            <ul>
              <li>
                a megbízó nevét vagy megnevezését, címét vagy székhelyét, adószámát, elérhetőségét, továbbá a
                képviseletében eljáró személy nevét vagy megnevezését, címét vagy telephelyét és elérhetőségét,
              </li>
              <li>a felelős műszaki vezető megnevezését, nyilvántartási számát, névjegyzéki jelét és elérhetőségét,</li>
              <li>a felelős műszaki vezető díját, fizetési módját, határidejét, </li>
              <li>a felelős műszaki vezető feladatainak és felelősségének meghatározását. </li>
            </ul>
          </li>
        </ul>
        <p>
          A felelős műszaki vezető <strong>nem lehet</strong> az építészeti-műszaki dokumentáció engedélyezésében részt
          vevő hatóság, valamint a tevékenység és az engedélyező hatóság felügyeletét ellátó szerv köztisztviselője vagy
          kormánytisztviselője. A felelős műszaki vezető nem végezhet építésügyi műszaki szakértői és építési műszaki
          ellenőri tevékenységet azon kivitelezési tevékenység esetében, ahol részben vagy egészben építési-szerelési
          munkát vezet.
        </p>
        <p>
          A felelős műszaki vezető <strong>nem láthat el</strong> felelős műszaki vezetői feladatokat olyan
          építési-szerelési munka esetében, ahol az építésügyi műszaki szakértői vagy építési műszaki ellenőri
          tevékenységet olyan gazdálkodó szervezet végzi, amelynek tagja, illetve amellyel munkavégzésre irányuló
          jogviszonyban áll.
        </p>
        <p>
          A felelős műszaki vezető <strong>nem végezhet</strong> építési műszaki ellenőri tevékenységet azon
          kivitelezési tevékenység esetében, ahol részben vagy egészben építési-szerelési munkát vezet. A felelős
          műszaki vezető nem láthat el felelős műszaki vezetői feladatokat olyan építési-szerelési munka esetében, ahol
          az építési műszaki ellenőri tevékenységet olyan gazdálkodó szervezet végzi, amelynek tagja, illetve amellyel
          munkavégzésre irányuló jogviszonyban áll
        </p>
        <p>
          Szólnunk kell még a felelős műszaki vezetők továbbképzéséről: a már hivatkozott kormányrendelet legutóbbi
          változása jelentős változást hozott 2017. évkezdettől a felelős műszaki vezetők továbbképzését illetően,
          ugyanis visszaállította az 2013. évi végéig életben volt szabályozást, ami szerint ötévente mind az építési
          műszaki ellenőrök, mind a felelős műszaki vezetők (akik tehát nem kamarai tagsághoz kötött jogosultságú
          szakmagyakorlók) kötelező és szakmai továbbképzésen kell részt vegyenek. Ezzel kapcsolatban a 266/2013. (VII.
          11.) Kormányrendelet a következőket rögzíti:
        </p>
        <p>
          <i>
            „36. § (1) A kötelező továbbképzés tematikáját jogosultsági szakterületenként a miniszter határozza meg, az
            ehhez kapcsolódó tananyagot az országos kamara dolgozza ki és a miniszternek mutatja be. Az oktatási
            anyagokat a kamara elektronikusan közzéteszi.
          </i>
        </p>
        <p>
          <i>
            (2) A szakmai továbbképzés tematikáját, rendszerét, metódusát, értékelését, az országos kamarák saját
            hatáskörben, szabályzatban állapítják meg.
          </i>
        </p>
        <p>
          <i>
            37. § (1) A 36. § (4) bekezdése szerinti továbbképzés teljesítésének elektronikus formában történő igazolása
            az országos kamara feladata. A területi kamara köteles közhiteles nyilvántartásában naprakészen vezetni az
            igazolások tartalma alapján az adott továbbképzési időszak teljesítését az egyes szakmagyakorlók
            tekintetében. Az egyes továbbképzési ciklusok teljesítése vizsgálatának alapjául a kamarai nyilvántartás
            szolgál.”
          </i>
        </p>
        <p>
          Mind a Magyar Mérnöki Kamara, mind Magyar Építész Kamara, illetve területi szerveik nagy hangsúlyt fektetnek
          ezekre a továbbképzésekre; a honlapjaikon részletes és naprakész információk találhatók:
        </p>
        <ul>
          <li>
            <a target="_blank" rel="noopener noreferrer" href="https://www.mmk.hu/szolgaltatasok/tovabbkepzes">
              az MMK összefoglalója
            </a>
          </li>
          <li>
            <a target="_blank" rel="noopener noreferrer" href="http://mek.hu/index.php?link=tovabbkepzes_rendszere">
              a MÉK összefoglalója
            </a>
          </li>
        </ul>
        <p>
          Amennyiben Felelős műszaki vezetőre van szüksége, vegye fel velünk a kapcsolatot, elérhetőségeink egyikén,
          hogy Önnek is mihamarabb segíteni tudjunk!
        </p>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
